"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var hocs_1 = require("../hocs");
var StyledFlexGridContainer_1 = require("./StyledFlexGridContainer");
var FlexGridContainer = function (props) {
    var children = props.children, tag = props.tag, rest = tslib_1.__rest(props, ["children", "tag"]);
    var StyledComponent = tag ? StyledFlexGridContainer_1.StyledFlexGridContainer.withComponent(tag) : StyledFlexGridContainer_1.StyledFlexGridContainer;
    return React.createElement(StyledComponent, tslib_1.__assign({}, rest), children);
};
var FlexGridContainerWrapper = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(FlexGridContainer);
exports.FlexGridContainer = FlexGridContainerWrapper;
//# sourceMappingURL=FlexGridContainer.js.map